module.exports = __webpack_public_path__ + "media/back-to-school/rc-a847e96f.webp";